import type React from 'react';

import { Separator } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { Share } from '../Share';
import { SignatureStatsActive } from '../Stats';

export const SideSignedNonPromotable: React.FC<EmptyProps> = () => {
	return (
		<div className="flex flex-col gap-6">
			<SignatureStatsActive />
			<Separator orientation="horizontal" className="border-stroke-weak" />
			<h2 className="sr-only">
				<Translate value="fe.components.petition_share.action" />
			</h2>
			<Share forMobileView={false} />
		</div>
	);
};
